import { createReduxConstants } from '@bibliocommons/utils-redux';

// bundle -> [array, of, feature, flags]
export const OPT_IN_BUNDLES = {
  nerf_search: ['nerf_search']
};

export default createReduxConstants('OPT_IN', {
  TOGGLE_OPT_IN_FEEDBACK_FORM: null,
  DISMISS_OPT_IN: null,
  CLOSE_FEEDBACK_SUCCESS: null,
  SUBMIT_OPT_IN_FEEDBACK_REQUEST: null,
  SUBMIT_OPT_IN_FEEDBACK_SUCCESS: null,
  SUBMIT_OPT_IN_FEEDBACK_FAILURE: null,
  OPT_IN_REQUEST: null,
  OPT_IN_SUCCESS: null,
  OPT_IN_FAILURE: null,
  OPT_OUT_REQUEST: null,
  OPT_OUT_SUCCESS: null,
  OPT_OUT_FAILURE: null
});



// WEBPACK FOOTER //
// ./app/constants/OptInConstants.js